
import { supabase } from '@/lib/supabase/client';
import { DEFAULT_ROLE } from './constants';

/**
 * Get user role from session metadata
 * @returns Role string or null if not found
 */
export const getRoleFromSessionMetadata = async () => {
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    
    if (sessionData?.session?.user?.app_metadata?.role) {
      const roleName = typeof sessionData.session.user.app_metadata.role === 'string' 
        ? sessionData.session.user.app_metadata.role.toUpperCase() 
        : 'USER';
      
      console.log("[roleUtils] Found role in session metadata:", roleName);
      return roleName;
    }
    return null;
  } catch (error) {
    console.error("[roleUtils] Error checking session metadata:", error);
    return null;
  }
};

/**
 * Get user role using RPC function
 * @param userId User ID
 * @returns Role string or null if not found
 */
export const getRoleFromRPC = async (userId: string) => {
  try {
    // Try to use get_auth_user_role RPC function
    const { data, error } = await supabase.rpc('get_auth_user_role', { p_user_id: userId });
    
    if (error) {
      // Function might not exist or has different signature
      console.log("[roleUtils] RPC error:", error);
      return null;
    }
    
    if (data) {
      console.log("[roleUtils] Role from RPC:", data);
      return data;
    }
    
    return null;
  } catch (error) {
    console.error("[roleUtils] Error in getRoleFromRPC:", error);
    return null;
  }
};

/**
 * Check if user is a dealer
 * @param userId User ID
 * @param executeWithTimeout Timeout execution function
 * @returns 'DEALER' if user is a dealer, null otherwise
 */
export const checkDealerStatus = async (userId: string, executeWithTimeout: any) => {
  try {
    console.log("[roleUtils] Checking dealer status for:", userId);
    const { data: dealerData, error: dealerError } = await executeWithTimeout(
      async () => {
        return await supabase
          .from('dealers')
          .select('activated')
          .eq('user_id', userId)
          .single();
      },
      5000
    );
    
    if (!dealerError && dealerData && dealerData.activated) {
      console.log("[roleUtils] User has an activated dealer account");
      return 'DEALER';
    }
    
    return null;
  } catch (error) {
    console.error("[roleUtils] Error checking dealer status:", error);
    return null;
  }
};

/**
 * Create default role constants file if it doesn't exist
 */
